import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "53",
  height: "50",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FBFCFD",
      "fill-rule": "evenodd",
      d: "M27.824 49.94c-7.49-.184-15.118-1.408-20.222-6.896-5.587-6.01-8.4-14.26-6.965-22.34C2.159 12.135 6.895 3.334 15.147.577c7.628-2.548 14.587 3.918 21.447 8.116 5.608 3.43 11.113 6.984 13.34 13.17 2.64 7.33 4.223 16.09-.597 22.21-4.84 6.146-13.696 6.06-21.513 5.868",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }